import { render } from "./PartnerAdmin.vue?vue&type=template&id=f4545dbe&scoped=true"
import script from "./PartnerAdmin.vue?vue&type=script&lang=js"
export * from "./PartnerAdmin.vue?vue&type=script&lang=js"

import "./PartnerAdmin.vue?vue&type=style&index=0&id=f4545dbe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4545dbe"]])

export default __exports__